import styled from 'styled-components';

const setOpacity = ({ isVisible }: { isVisible: boolean }) => (isVisible ? 1 : 0);

const CardWidget = styled.div<{ isVisible: boolean }>`
  opacity: 0;
  opacity: ${setOpacity};
`;

export default CardWidget;
